const getQueryAllParams = (url = window.location.href) => {
  const params = {};
  const searchParams = new URL(url).search;
  const urlSearchParams = new URLSearchParams(searchParams);
  urlSearchParams.forEach((val, key) => {
    params[key] = val;
  });

  return params;
};

const getQueryParam = (paramName) => {
  const params = getQueryAllParams();

  return params[paramName];
};

const dropSearchParamFromUrl = (url = window.location.href, param) => {
  const urlObj = new URL(url);
  const searchParams = urlObj.search;
  const urlSearchParams = new URLSearchParams(searchParams);

  urlSearchParams.delete(param);
  urlObj.search = urlSearchParams.toString();

  return urlObj.toString();
};

const convertPercentToDecimal = (number) => {
  if (!number || number === 0) return 0;

  return number / 100;
};

export {
  getQueryAllParams,
  getQueryParam,
  dropSearchParamFromUrl,
  convertPercentToDecimal,
};
